import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import { saveAs } from 'file-saver'
import { DOCUMENTS_API } from '../../../utils/consts'

export const exportLeavesDocs = async (thisObject) => {
  const showSwalError = (message = 'Gabim gjatë shkarkimit të dokumentit') => {
    Swal.fire({
      title: message,
      type: 'warning'
    })
  }
  try {
    const fromDate = moment(thisObject?.state?.fromDateValue)
    const toDate = moment(thisObject?.state?.toDateValue)

    if (fromDate.isValid() && toDate.isValid()) {
      const daysDifference = toDate.diff(fromDate, 'days')

      if (daysDifference > 31) {
        return Swal.fire({
          title: 'Gabim në zgjedhjen e datave',
          text: 'Periudha e zgjedhur nuk mund të jetë më e madhe se 1 muaj!',
          type: 'error'
        })
      }
    }

    Swal.fire({
      title: 'Ju lutem prisni...',
      text: 'Duke gjeneruar dokumentin',
      didOpen: () => {
        Swal.showLoading()
      }
    })

    const params = {
      ...thisObject?.state?.filters,
      fromDateValue: thisObject?.state?.fromDateValue,
      toDateValue: thisObject?.state?.toDateValue,
      search: thisObject?.state?.searchQuery || undefined,
      userID: thisObject?.state?.selectedUserID || undefined
    }
    const response = await axios.get(`${DOCUMENTS_API}/exportMultipleLeaves`, {
      responseType: 'blob',
      withCredentials: false,
      params
    })

    if (response?.data) {
      const contentType = response.headers['content-type'] || ''

      // Check if response is JSON (error response from backend)
      if (contentType.includes('application/json')) {
        const text = await response.data.text()
        const jsonData = JSON.parse(text)

        Swal.close()
        showSwalError(jsonData.message || 'Gabim gjatë shkarkimit të dokumentit')
        return
      }

      if (contentType.includes('application/zip')) {
        saveAs(response.data, 'Leaves.zip')
        Swal.close()
        Swal.fire({
          title: 'Te dhenat u shkarkuan me sukses.',
          text: 'Dokumenti eshte gjeneruar me sukses!',
          type: 'success'
        })
      } else {
        showSwalError()
      }
    } else {
      showSwalError()
    }
  } catch (error) {
    console.log('error', error)

    if (error.response?.data) {
      try {
        if (error.response.data instanceof Blob) {
          const text = await error.response.data.text()
          const jsonData = JSON.parse(text)
          Swal.close()
          showSwalError(jsonData.message || 'Gabim gjatë shkarkimit të dokumentit')
          return
        }
      } catch (parseError) {
        console.log('Error parsing error response:', parseError)
      }
    }

    Swal.close()
    showSwalError()
  }
}
